import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#000",
        "fill-rule": "evenodd",
        d: "M10.9 1.4c0-.6-.5-1-1-1s-1 .4-1 1v7.5H1.4c-.6 0-1 .5-1 1s.4 1 1 1h7.5v7.5c0 .6.5 1 1 1s1-.4 1-1v-7.5h7.5c.6 0 1-.5 1-1s-.4-1-1-1h-7.5z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h19.8v19.8H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }